import { render, staticRenderFns } from "./fund-related-content-panel.vue?vue&type=template&id=4dcd9d75&scoped=true&"
var script = {}
import style0 from "../../../assets/styles/panels/_PromoPanel.scss?vue&type=style&index=0&id=4dcd9d75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcd9d75",
  null
  
)

export default component.exports